import {
  Button,
  TextField,
  MenuItem,
  Box,
  DialogActions,
  DialogContent,
  Stack,
  DialogTitle,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useFormik } from "formik";
import { useAuthHeader, useAuthUser } from "react-auth-kit";
import * as yup from "yup";
import { dateToServer, prettify, renderDateUTC } from "../../../utils/utils";
import { useNewService, services } from "../useServiceQueries";

// == represents services Enum on the ws ==

const validationSchema = yup.object({
  service: yup.string("Servizio").required("Servizio è un campo obbligatorio!"),
  delivery: yup.number().min(1).max(2),
  note1: yup.string("Nota 1"),
  note2: yup.string("Nota 2"),
});

function AddService({ patient_id, doctor_id, closeModal }) {
  // === authentication ===
  const authUser = useAuthUser();

  // === web service queries/mutations ===
  const newServiceMutation = useNewService(closeModal);

  // === Form handling ===
  const formik = useFormik({
    initialValues: {
      service: "",
      start_date: null,
      end_date: null,
      delivery: 1,
      note1: "",
      note2: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      let newService = {
        ...values,
        patient_id: patient_id,
        start_date: dateToServer(values.start_date), // fix date
        end_date: dateToServer(values.end_date), // TODO. fix in change handler
      };

      // if not a doctor, add doctor_id
      if (authUser()?.role !== 3) {
        newService = {
          ...newService,
          doctor_id: doctor_id, // got from props
        };
      }

      // if superadmin, add org_id
      if (authUser()?.role === 1) {
        newService = {
          ...newService,
          org_id: 1, // TODO: superadmin account can choose (R-2)
        };
      }
      newServiceMutation.mutate(newService);
    },
  });

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <DialogTitle>Nuovo telemonitoraggio</DialogTitle>
        <DialogContent>
          <Stack direction="row" spacing={8} sx={{ width: "100%" }}>
            <Box sx={{ float: "left", width: "50%" }}>
              <TextField
                autoFocus
                select
                margin="dense"
                fullWidth
                id="service"
                name="service"
                label="Servizio (*)"
                type="text"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.service}
                error={formik.touched.service && Boolean(formik.errors.service)}
                helperText={formik.touched.service && formik.errors.service}
              >
                {services.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {prettify(option.label)}
                  </MenuItem>
                ))}
              </TextField>

              <DatePicker
                format="DD/MM/YYYY"
                id="start_date"
                name="start_date"
                label="Data di inizio"
                sx={{ marginTop: "2ch" }}
                value={formik.values.start_date}
                onChange={(value) =>
                  formik.setFieldValue("start_date", value, true)
                }
                slotProps={{
                  textField: {
                    variant: "standard",
                    error:
                      formik.touched.start_date &&
                      Boolean(formik.errors.start_date),
                    helperText:
                      formik.touched.start_date && formik.errors.start_date,
                  },
                }}
              />

              <DatePicker
                format="DD/MM/YYYY"
                id="end_date"
                name="end_date"
                label="Data di fine"
                sx={{ marginTop: "2ch" }}
                value={formik.values.end_date}
                onChange={(value) =>
                  formik.setFieldValue("end_date", value, true)
                }
                slotProps={{
                  textField: {
                    variant: "standard",
                    error:
                      formik.touched.end_date &&
                      Boolean(formik.errors.end_date),
                    helperText:
                      formik.touched.end_date && formik.errors.end_date,
                  },
                }}
              />
            </Box>

            <Box sx={{ float: "right", width: "50%" }}>
              <TextField
                margin="dense"
                fullWidth
                sx={{ marginTop: "15px" }}
                id="delivery"
                name="delivery"
                label="Consegna/Ritiro"
                select
                variant="standard"
                defaultValue={""}
                onChange={formik.handleChange}
                value={formik.values.delivery}
              >
                <MenuItem value={1}>Ritiro in studio</MenuItem>
                <MenuItem value={2}>Consegna a casa</MenuItem>
              </TextField>

              <TextField
                margin="dense"
                fullWidth
                id="note1"
                name="note1"
                label="Nota 1"
                multiline
                minRows={4}
                type="text"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.note1}
              />

              <TextField
                margin="dense"
                fullWidth
                id="note2"
                name="note2"
                label="Nota 2"
                multiline
                minRows={4}
                type="text"
                variant="standard"
                onChange={formik.handleChange}
                value={formik.values.note2}
              />
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button disabled={newServiceMutation.isLoading} type="submit">
            Conferma
          </Button>
          <Button
            disabled={newServiceMutation.isLoading}
            onClick={formik.handleReset}
          >
            Reset
          </Button>
          <Button
            disabled={newServiceMutation.isLoading}
            color="error"
            onClick={closeModal}
          >
            Annulla
          </Button>
        </DialogActions>
      </form>
    </>
  );
}

export default AddService;
